import StudentProgressReport from "./StudentProgressReport";

export default StudentProgressReport;
